const pixelConfig = {
	'trash-joes-demo': 'PIXEL_ID_FOR_THE_DEMO',
	// 'dependable-disposal': '738250057027129',
	'dependable-disposal': '836687825052125',
	// Add more entries as needed
};

export default pixelConfig;
